// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__3CNm8","headerContent":"styles_headerContent__h1sVl"};